module.exports = __webpack_public_path__ + "static/EDManteca-Regular-5e005743e97cd5b460e2025686cb6627.woff2";